var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"height":"80vh"},attrs:{"align":"center","justify":"center"}},[_c('NamesComparisonForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }